module.exports = __webpack_public_path__ + "img/caretArrowDown_w.7e3ef6dc.svg";